import cookiesTranslation from './index.json';

export default cookiesTranslation;
